import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const BarGraph = ({ data,from,wise }) => {
  const CustomYAxisTick = (props) => {
    const { x, y, payload } = props;
  
    return (
      <g transform={`translate(${x},${y})`}>
        <text  textAnchor="end" fill="#666" fontFamily='sans-serif' fontSize={'11px'} >
          {`${wise==="amount"?"₹":""}${payload.value}`}
        </text>
      </g>
    );
  };
  return (
    <BarChart width={window.innerWidth/2.8} height={window.innerHeight/2.3} data={data}>
      <CartesianGrid  vertical={false} strokeDasharray="3 3" />
      <XAxis dataKey={`${from==="All"?"category":"orderDate"}`} fontSize={'11px'} />
      <YAxis tick={<CustomYAxisTick />} />
      <Tooltip />
      <Legend />
      {wise==="amount"&&(<Bar dataKey="orderAmount" fill="#8884d8" />)}
      {wise==="order"&&(<Bar dataKey="orderCount" fill="#82ca9d" />)}
    </BarChart>
  );
};

export default BarGraph;
